import React from "react";
import PropTypes from "prop-types";

const DescriptionFields = ({ 
  engDescription, 
  jpDescription, 
  onChange, 
  errors 
}) => {
  return (
    <>
      {/* English Description */}
      <div className="form-group">
        {/* <label className="form-label">English Description</label> */}
        <textarea
          name="engDescription"
          placeholder="Enter English description"
          value={engDescription}
          onChange={(e) =>
            onChange({
              name: "engDescription",
              value: e.target.value,
            })
          }
          className={errors.engDescription ? "error" : ""}
          rows={4}
        />
        {errors.engDescription && (
          <div className="error-message">{errors.engDescription}</div>
        )}
      </div>

      {/* Japanese Description */}
      <div className="form-group">
        {/* <label className="form-label">Japanese Description</label> */}
        <textarea
          name="jpDescription"
          placeholder="Enter Japanese description"
          value={jpDescription}
          onChange={(e) =>
            onChange({
              name: "jpDescription",
              value: e.target.value,
            })
          }
          className={errors.jpDescription ? "error" : ""}
          rows={4}
        />
        {errors.jpDescription && (
          <div className="error-message">{errors.jpDescription}</div>
        )}
      </div>
    </>
  );
};

DescriptionFields.propTypes = {
  engDescription: PropTypes.string.isRequired,
  jpDescription: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

export default DescriptionFields;